<template>
  <div class="row">
    <div class="span-16-lg span-16-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
      <h2>Fonts</h2>

      <h1 class="title">Title</h1>
      <h1>Header 1</h1>
      <h2>Header 2</h2>
      <p class="subheader">Subheader</p>
      <p class="large">Paragraph Large</p>
      <p class="large">{{lorem_ipsum}}</p>
      <p>Paragraph</p>
      <p>{{lorem_ipsum}}</p>
    </div>   
  </div>
</template>

<script>
  export default {
    data () {
      return {
        lorem_ipsum: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus lacinia tempor ante, eget pellentesque risus pharetra vel. Proin sit amet maximus erat, vestibulum fermentum nunc. Donec viverra pulvinar orci ac vehicula. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum commodo nec magna at vestibulum.'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// fonts.vue?7ae4c9dc